import React from "react";
import "./LegalPages.css";

const AvisosLegales = () => (
  <div className="legal-page">
    <h1>Aviso Legal</h1>

    <section>
      <p className="bienvenido">Bienvenido a este espacio</p>
      <p>
        Como usuario, es importante que conozcas estos términos antes de continuar navegando. <br />
        <b>Sparkling Tech Solutions, S.L.</b> como responsable de esta página web, se compromete a procesar la información de nuestros usuarios y clientes con plenas garantías y cumplir con los requisitos nacionales y europeos que regulan la recopilación y uso de datos personales de nuestros usuarios.
      </p>
      <p>
        Esta página Web, por lo tanto, cumple de forma rigurosa con la Ley Orgánica de Protección de Datos de Carácter Personal (en adelante LOPD) y demás normativa aplicable, con el Reglamento (UE) 2016/279 del Parlamento Europeo y del Consejo de 27 de abril de 2016 relativo a la protección de las personas físicas (en adelante RGPD) y con la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y Comercio Electrónico (en adelante LSSICE).
      </p>
    </section>

    <section>
      <h2>Datos del Responsable</h2>
      <ul>
        <li><b>Identidad del Responsable</b>: Sparkling Tech Solutions, S.L.</li>
        <li><b>Nombre comercial</b>: Sparkling Tech</li>
        <li><b>NIF/CIF</b>: B19364702</li>
        <li><b>Datos Registro Mercantil</b>: Hoja GC-63493 (Registro Mercantil de Las Palmas)</li>
        <li><b>Dirección</b>: Las Palmas de Gran Canaria</li>
        <li><b>Correo electrónico</b>: <a href="mailto:info@sparklingtech.es">info@sparklingtech.es</a></li>
        <li><b>Actividad</b>: Investigación científica y técnica - Soluciones Tecnológicas</li>
      </ul>
    </section>

    <section>
      <h2>Condiciones Generales de Uso</h2>
      <p>
        Las presentes Condiciones Generales regulan el uso (incluyendo el acceso) de las páginas web integrantes del sitio web de <b>Sparkling Tech Solutions, S.L.</b> incluidos los contenidos y servicios puestos a disposición en ellas. Toda persona que acceda a la web <a href="sparklingtech.es">sparklingtech.es</a> (“usuario”) acepta someterse a las Condiciones Generales vigentes en cada momento. Por usuario se entiende a la persona que acceda, navegue, utilice o participe en los servicios y actividades desarrolladas en el sitio web.
      </p>
    </section>

    <section>
      <h2>Datos Personales que Recopilamos y Cómo lo Hacemos</h2>
      <p>
        Los términos relativos a la privacidad y protección de datos, están estipulados en nuestra <a href="/politica-privacidad">Política de privacidad</a>.
      </p>
    </section>

    <section>
      <h2>Obligaciones y Compromisos de los Usuarios</h2>
      <p>
        El usuario queda informado, y acepta que, el acceso a la presente web, no supone en modo alguno, el inicio de una relación comercial con <b>Sparkling Tech Solutions, S.L.</b> De esta forma, el usuario se compromete a utilizar la Web, sus servicios y contenidos sin contravenir la legislación vigente, la buena fe, los usos generalmente aceptados y el orden público. 
      </p>
      <p>
        Así mismo, queda prohibido, el uso de la Web con fines ilícitos o lesivos contra <b>Sparkling Tech Solutions, S.L.</b> o cualquier tercero o que, de cualquier forma, puedan causar perjuicio o impedir el normal funcionamiento de la Web.
      </p>
      <p>
        Respecto de los contenidos (informaciones, textos, gráficos, archivos de sonido y/o imagen, fotografías, diseños, etc.), se prohíbe:
        <ul>
          <li>Su reproducción, distribución o modificación, a menos que se cuente con la autorización de sus legítimos titulares o resulte legalmente permitido.</li>
          <li>Cualquier vulneración de los derechos de la empresa o de sus legítimos titulares sobre los mismos.</li>
          <li>Su utilización para todo tipo de fines comerciales o publicitarios, distintos de los estrictamente permitidos.</li>
          <li>Cualquier intento de obtener los contenidos de la Web por cualquier medio distinto de los que se pongan a disposición de los usuarios, así como de los que habitualmente se empleen en la red, siempre que no causen perjuicio alguno a la Web de <b>Sparkling Tech Solutions, S.L.</b></li>
        </ul>
      </p>
      <p>
        En la utilización de la web <a href="sparklingtech.es">sparklingtech.es</a> el usuario se compromete a no llevar a cabo ninguna conducta que pudiera dañar la imagen, los intereses y los derechos de Sparkling Tech Solutions, S.L. o de terceros o que pudiera dañar, inutilizar o sobrecargar el portal <a href="sparklingtech.es">sparklingtech.es</a>, o que impidiera, de cualquier forma, la normal utilización de la web.
      </p>
      <p>
        No obstante, el usuario debe ser consciente de que las medidas de seguridad de los sistemas informáticos en Internet no son enteramente fiables y que, por tanto, <b>Sparkling Tech Solutions, S.L.</b>, no puede garantizar la inexistencia de malware u otros elementos que puedan producir alteraciones en los sistemas informáticos (software y hardware) del usuario o en sus documentos electrónicos y ficheros contenidos en los mismos, aunque ponga todos los medios necesarios y las medidas de seguridad oportunas para evitar la presencia de estos elementos dañinos.
      </p>
    </section>


    <section>
      <h2>Medidas de Seguridad</h2>
      <p>
        Los datos personales comunicados por el usuario a <b>Sparkling Tech Solutions, S.L.</b>, pueden ser almacenados ficheros, cuya titularidad corresponde en exclusiva a <b>Sparkling Tech Solutions, S.L.</b>, asumiendo ésta todas las medidas de índole técnica, organizativa y de seguridad que garantizan la confidencialidad, integridad y calidad de la información contenida en las mismas de acuerdo con lo establecido en la normativa vigente en protección de datos. <b>Sparkling Tech Solutions, S.L.</b> utiliza un canal seguro y los datos transmitidos son cifrados gracias a protocolos a https, por tanto, garantizamos las mejores condiciones de seguridad para que la confidencialidad de los usuarios esté garantizada.
      </p>
    </section>

    <p style={{ fontSize: "14px", marginTop: "10px",  color: "rgba(0, 0, 0, 0.6)" }}>Fecha de actualización 04/08/2025</p>
  </div>
);

export default AvisosLegales;
